var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_set"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_vector",
    d: "M4.10362 6.11496L2.33362 7.88496L12.3336 17.885L22.3336 7.88496L20.5636 6.11496L12.3336 14.345L4.10362 6.11496Z",
    fill: "#DD5800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangArrowDown);
export default __webpack_public_path__ + "static/media/lang_arrow_down.92518e6a70ff4a44558391f0876ba3c7.svg";
export { ForwardRef as ReactComponent };